if ($('.x-sort-menu').length > 0) {
  var sortMenuTop = 0;
  var sortMenu = $('.x-sort-menu');
  var sortBar = $('.x-sort-bar');
  var mql = window.matchMedia("screen and (min-width: 1039px)");
  var boxFilters = $('.x-filters');
  var buttonOpenFilters = $('.x-filters-open');

  window.addEventListener('scroll', function() {
    setFixedSortMenu();
  });

  function setFixedSortMenu() {
    //sortMenuTop > 0 fix for mozilla
    if (sortMenuTop < $(window).scrollTop() && mql.matches && sortMenuTop > 0) {
      sortMenu.addClass('sort-menu--fixed');
      $('body').css('padding-top', sortMenu.height());
    } else {
      sortMenu.removeClass('sort-menu--fixed');
      $('body').css('padding-top', 0);
    }
  }

  function clickPagination() {
    if (sortMenuTop < $(window).scrollTop() && mql.matches) {
      $('html, body').animate({scrollTop: sortMenuTop + 2}, '200');
    } else if (sortMenuTop < $(window).scrollTop() && window.matchMedia("screen and (max-width: 767px)").matches) {
      $('html, body').animate({scrollTop: sortMenuTop - $('.x-main-header').height()}, '200');
    }
  }

  function heightSectionFilters() {
    boxFilters.css('max-height', $(window).height() - sortBar.height());

    if (boxFilters.is(':visible') && !checkIOS()) {
      buttonOpenFilters.trigger('click');
    }
  }

  function getSortMenuTop() {
    sortMenuTop = $('.header__main-wrapper').height() + $('.accountants-banner').outerHeight();
  }

  function toggleFilters() {
    var isAnimateFilters = false;

    buttonOpenFilters.click(function(e) {
      e.preventDefault();

      if (!isAnimateFilters) {
        isAnimateFilters = true;
        var that = $(this);
        var filterLabel = $(this).children('.x-label');
        var tmpLabelText = filterLabel.text();

        if (!boxFilters.is(':visible')) {
          boxFilters.slideDown(200, function() {
            isAnimateFilters = false;
          });
          $(this).addClass('filters-open--show');
          changeLabel();

          if ($(window).scrollTop() < sortMenuTop)
            $('html, body').animate({scrollTop: sortMenuTop}, '200', function(){
              boxFilters.css('max-height', $(window).height() - sortBar.height() /*- sortMenuTop + $(window).scrollTop()*/);
            });

          //overflow
          $('body').addClass('noscroll-body');
          //fix for iPhone
          if (checkIOS()) {
            $('.page__wrapper').addClass('noscroll-wrapper');
            $('.page__wrapper').css({'margin-top': -(sortMenuTop), 'overflow': 'visible'});
          }

          //hide menu for mobile
          if (!mql.matches) {
            $('.nav-switch--fixed').hide();
            $('.header__main').hide();
          }
        } else {
          boxFilters.slideUp(200, function() {
            that.removeClass('filters-open--show');
            changeLabel();

            //overflow
            $('body').removeClass('noscroll-body');
            //fix for iPhone
            if (checkIOS()) {
              $('.page__wrapper').removeClass('noscroll-wrapper');
              $('.page__wrapper').css({'margin-top': 0, 'overflow': 'hidden'});
            }

            isAnimateFilters = false;
            //show menu and header for mobile
            if (!$('.header__main').is(':visible')) {
              $('.nav-switch--fixed').show();
              $('.header__main').show();
            }

            // $('.select2-drop').css('left', $('.select-number').offset().left);
          });
        }
      }

      function changeLabel() {
        filterLabel.text(filterLabel.data('filterLabel'));
        filterLabel.data('filterLabel', tmpLabelText);
      }
    });
  }

  function setSelect2() {
    //select2 - numbers
    $('select.select2').each(function() {
      $(this).select2({
        minimumResultsForSearch: 32
      });
    });

    $('select.select2').on("select2-open", function () {
      //close filters box
      if (boxFilters.is(':visible')) {
        buttonOpenFilters.trigger('click');
      }
      $('.select3').removeClass('open');
    });
  }

  window.addEventListener('resize', function() {
    heightSectionFilters();
    getSortMenuTop();
  });

  mql.addListener(resizeOrientation);

  function resizeOrientation(mql) {
    //for tablets remove fixed from menu and slideUp box filters
    if (!mql.matches) {
      sortMenu.removeClass('sort-menu--fixed');
      $('body').css('padding-top', 0);
      if (boxFilters.is(':visible')) {
        buttonOpenFilters.trigger('click');
      }
    }
  }

  function switchView() {
    var switchTrigger = document.querySelectorAll('.x-view-switch');
    var viewOption = document.querySelector('.x-accountants-boxes');
    var switchList = document.querySelector('.x-view-switch--list');

    // Array.forEach IE fix
    (function () {
      if ( typeof NodeList.prototype.forEach === "function" ) return false;
      NodeList.prototype.forEach = Array.prototype.forEach;
    })();

    if (localStorage.getItem('list') !== null) {
      getFav = localStorage.fav;
      viewOption.classList.add('accountants-boxes--list');
      viewOption.classList.remove('accountants-boxes--tiles');
      switchTrigger.forEach(function(trigger){
        trigger.classList.remove('active');
      });
      switchList.classList.add('active');
    }

    function switchRemoveClass() {
      switchTrigger.forEach(function(trigger){
        var switchViewOption = trigger.dataset.switch;
        if (viewOption.classList.contains('accountants-boxes--' + switchViewOption)) {
          viewOption.classList.remove('accountants-boxes--' + switchViewOption);
        }
        trigger.classList.remove('active');
      });
    }

    function switchViewKind(item) {
      var switchViewOption = this.dataset.switch;
      switchRemoveClass();
      this.classList.add('active');
      viewOption.classList.add('accountants-boxes--' + switchViewOption);
      if (viewOption.classList.contains('accountants-boxes--list')) {
        localStorage.setItem('list', 'active');
      } else {
        localStorage.removeItem('list');
      }
    }
    switchTrigger.forEach(function(trigger){
      trigger.addEventListener('click', switchViewKind);
    });
  }
  switchView()

  function checkIOS () {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  $(document).ready(function() {
    getSortMenuTop();
    heightSectionFilters();
    toggleFilters();
    setSelect2();
    setFixedSortMenu();

    $('body').on("click", '.x-cancel-form-button' ,function (e) {
      e.preventDefault();
      buttonOpenFilters.trigger('click');
    });

    //pagination
    $('body').on('click', '.x-pagination', function(e) {
      e.preventDefault();
      clickPagination();
    });

    //order
    
    //order mobile
    $('body').on("change", '.sort-select-mobile select' ,function () {
      $(this).prev().text($(this).children('option:selected').text());
      //close filters box
      if (boxFilters.is(':visible')) {
        buttonOpenFilters.trigger('click');
      }
    });
  });
}
